import React, { useState } from 'react';

import { GroupSubscriptionRecipient } from '../../../../utils/backend-api/groupSubscription';
import EditRecipientCard from './EditRecipientCard';
import ShowRecipientCard from './ShowRecipientCard';
import styles from './styles.module.scss';

const SubscriptionOverview = ({
  recipients,
  team,
}: {
  recipients: GroupSubscriptionRecipient[];
  team?: boolean;
}) => {
  const [editRecipientId, setEditRecipientId] = useState();
  return (
    <div className={styles.overViewContainer}>
      {recipients.map((recipient) => (
        <>
          {recipient.recipientId !== editRecipientId ? (
            <ShowRecipientCard recipient={recipient} setEditRecipientId={setEditRecipientId} />
          ) : (
            <EditRecipientCard
              recipient={recipient}
              setEditRecipientId={setEditRecipientId}
              team={team}
            />
          )}
        </>
      ))}
    </div>
  );
};

export default SubscriptionOverview;
